import {
    Row,
    Col,
    CardHeader,
} from "reactstrap";
import Button from "../UIButton/UIButton";
import tenant from '../../assets/img/icons/common/tenant.png';
import location from '../../assets/img/icons/common/location.png';
import subOrg from '../../assets/img/icons/common/subOrg.png';

const IconLabel = ({ src, alt, label }) => (
    <div
        className="d-flex align-items-center mx-2 text-muted"
        style={{ fontSize: "0.85rem" }}
    >
        <img
            src={src}
            alt={alt}
            style={{
                height: "18px",       // fixed height
                width: "auto",        // keep aspect ratio
                filter: "grayscale(100%)",
                opacity: 0.6,
                marginRight: "6px",
            }}
        />
        <span>{label}</span>
    </div>
);

const MainTreeHeader = ({
    checkedItems,
    deleteSelected,
    moveSelected,
}) => {
    return (
        <CardHeader className="p-0">
            <div className="p-3 d-flex align-items-center" style={{ minHeight: "100px" }}>
                <Row className="w-100 ml-2">
                    <Col md={6} className="d-flex align-items-center">
                        <h2 className="mb-0">Location Management</h2>
                    </Col>
                    <Col md={6} className="d-flex flex-column align-items-end justify-content-center">
                        <div className="d-flex mb-2">
                            <IconLabel src={tenant} alt="Headquarters" label="Headquarters" />
                            <IconLabel src={subOrg} alt="Organization" label="Organization" />
                            <IconLabel src={location} alt="Location" label="Location" />
                        </div>
                        <div className="d-flex">
                            <Button
                                variant="primary"
                                size="medium"
                                onClick={moveSelected}
                                disabled={checkedItems.length === 0}
                            >
                                Move Selected
                            </Button>
                            <Button
                                variant="danger"
                                size="medium"
                                onClick={deleteSelected}
                                disabled={checkedItems.length === 0}
                            >
                                Delete Selected
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </CardHeader>
    );
};

export default MainTreeHeader;
